// extracted by mini-css-extract-plugin
export default {"cls1":"Rating-cls1___G","cls2":"Rating-cls2_a82 Rating-cls1___G"};